/**
 * 通用翻页组件 - 原生 JS 实现
 * @param {Object} options 配置项
 * @param {string|HTMLElement} options.container 挂载的容器选择器或 DOM 元素
 * @param {number} options.total 总条数
 * @param {number} [options.pageSize=10] 每页条数
 * @param {number} [options.currentPage=1] 当前页码
 * @param {number} [options.maxVisible=5] 当前页两侧最多显示的页码数（不含首尾）
 * @param {function(number, number)} [options.onChange] 页码或每页条数变化时的回调 (page, pageSize)
 */
function Pagination(options) {
  var container = typeof options.container === 'string'
    ? document.querySelector(options.container)
    : options.container;
  var total = options.total || 0;
  var pageSize = options.pageSize || 10;
  var currentPage = options.currentPage || 1;
  var maxVisible = options.maxVisible !== undefined ? options.maxVisible : 5;
  var onChange = options.onChange || function() {};

  var totalPages = Math.max(1, Math.ceil(total / pageSize));
  currentPage = Math.max(1, Math.min(currentPage, totalPages));

  function getPageNumbers() {
    var pages = [];
    if (totalPages <= maxVisible + 4) {
      for (var i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }
    var left = Math.max(2, currentPage - maxVisible);
    var right = Math.min(totalPages - 1, currentPage + maxVisible);
    pages.push(1);
    if (left > 2) pages.push('ellipsis-left');
    for (var j = left; j <= right; j++) pages.push(j);
    if (right < totalPages - 1) pages.push('ellipsis-right');
    if (totalPages > 1) pages.push(totalPages);
    return pages;
  }

  function render() {
    totalPages = Math.max(1, Math.ceil(total / pageSize));
    currentPage = Math.max(1, Math.min(currentPage, totalPages));

    var wrap = document.createElement('div');
    wrap.className = 'pagination';

    var prev = document.createElement('span');
    prev.className = 'pagination-arrow' + (currentPage <= 1 ? ' disabled' : '');
    prev.textContent = '<';
    prev.setAttribute('data-action', 'prev');
    wrap.appendChild(prev);

    var pageNumbers = getPageNumbers();
    pageNumbers.forEach(function(item) {
      if (item === 'ellipsis-left' || item === 'ellipsis-right') {
        var ellipsis = document.createElement('span');
        ellipsis.className = 'pagination-ellipsis';
        ellipsis.textContent = '...';
        wrap.appendChild(ellipsis);
      } else {
        var pageEl = document.createElement('span');
        pageEl.className = 'pagination-dot' + (item === currentPage ? ' active' : '');
        pageEl.setAttribute('data-page', item);
        wrap.appendChild(pageEl);
      }
    });

    var next = document.createElement('span');
    next.className = 'pagination-arrow' + (currentPage >= totalPages ? ' disabled' : '');
    next.textContent = '>';
    next.setAttribute('data-action', 'next');
    wrap.appendChild(next);

    wrap.addEventListener('click', function(e) {
      var target = e.target;
      var isDot = target.classList.contains('pagination-dot');
      var isArrow = target.classList.contains('pagination-arrow');
      if ((!isDot && !isArrow) || target.classList.contains('disabled')) return;
      var action = target.getAttribute('data-action');
      var page = target.getAttribute('data-page');
      if (action === 'prev' && currentPage > 1) {
        currentPage--;
        renderToContainer();
        onChange(currentPage, pageSize);
      } else if (action === 'next' && currentPage < totalPages) {
        currentPage++;
        renderToContainer();
        onChange(currentPage, pageSize);
      } else if (page) {
        currentPage = parseInt(page, 10);
        renderToContainer();
        onChange(currentPage, pageSize);
      }
    });

    return wrap;
  }

  function renderToContainer() {
    if (!container) return;
    container.innerHTML = '';
    container.appendChild(render());
  }

  this.update = function(opts) {
    if (opts.total !== undefined) total = opts.total;
    if (opts.pageSize !== undefined) pageSize = opts.pageSize;
    if (opts.currentPage !== undefined) currentPage = opts.currentPage;
    renderToContainer();
  };

  this.getPage = function() { return currentPage; };
  this.getPageSize = function() { return pageSize; };
  this.getTotal = function() { return total; };

  renderToContainer();
}

// 兼容模块化
if (typeof module !== 'undefined' && module.exports) {
  module.exports = Pagination;
}
if (typeof window !== 'undefined') {
  window.Pagination = Pagination;
}
